/**
 * Improved pagination controls
 *
 * - pass it a collection
 * - initially, prev/next buttons are disabled
 * - you can enable buttons manually by assigning an action
 * - interpret results from an xhr request, get pagination from API
 * - create an action for each button which fetches the collection
 *   and triggers an event with the results
 */
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import template from '@/../templates/pagination-controls.hbs';

const apiCh = Radio.channel('api');
    function create_filter(ids) {
        return function(model) {
            return (ids.indexOf(model.id) > -1);
        };
    }
    var pagination_view = Marionette.View.extend({
        template: Handlebars.compile(template),
        ui: {
            'prev': '.prev',
            'next': '.next'
        },
        events: {
            'click @ui.prev': 'fetch_prev',
            'click @ui.next': 'fetch_next'
        },
        initialize: function(options){
            // These two functions are usually called in the context
            // of a jquery promise, where 'this' is the jqxhr object.
            // In our case we want 'this' to be this view. If we need access
            // to the jqxhr object, it also gets passed as the third argument
            // of ajax().done() or ajax().then()
            _.bindAll(this, 
                'update_prev_next_from_response',
                'trigger_new_page'
            );
            // Set up an internal model to track view state.
            this.model = this.getOption('model') || new Backbone.Model({
                prev: this.getOption('prev') || null,
                next: this.getOption('next') || null
            });
            this.listenTo(this.model, 'change:prev change:next', this.render);
        },
        fetch_prev: function() {
            return this.collection.fetch({
                url: this.model.get('prev')
            })
            .done(this.update_prev_next_from_response)
            .done(this.trigger_new_page);
        },
        fetch_next: function() {
            return this.collection.fetch({
                url: this.model.get('next')
            })
            .done(this.update_prev_next_from_response)
            .done(this.trigger_new_page);
        },
        /**
         * Modules listening for 'page' will get an event with this
         * signature:
         * function(view, filter, items)
         * @param view this pagination view
         * @param filter a filter function you can use on the collection
         * @param items a list of the items from the collection represented in
         *              the fetched data
         */
        trigger_new_page: function(data) {
            var filter;
            var items = [];
            if ( data && data.data && this.collection.type == 'transaction') {
                data.data.forEach((r)=> {
                    this.collection.add(r);
                    filter = true;
                    items.push(apiCh.request(this.collection.type, r.id));
                });
            } else {
                filter = data && data.data && create_filter(_.pluck(data.data, 'id'));
                items = this.collection.filter(filter);
            }

            this.triggerMethod('page', filter, items);
        },
        update_prev_next_from_response: function(data) {
            this.model.set({
                prev: data && data.links && data.links.prev || null,
                next: data && data.links && data.links.next || null
            });
        }
    });
    export default pagination_view;

